var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraCapture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3453 2.9755L11.347 1.39825C11.1366 1.153 10.8483 1 10.525 1H7.075C6.75175 1 6.46338 1.153 6.253 1.39825L5.25475 2.9755C5.04438 3.22112 4.77325 3.4 4.45 3.4H2.2C1.88174 3.4 1.57652 3.52643 1.35147 3.75147C1.12643 3.97652 1 4.28174 1 4.6V11.8C1 12.1183 1.12643 12.4235 1.35147 12.6485C1.57652 12.8736 1.88174 13 2.2 13H15.4C15.7183 13 16.0235 12.8736 16.2485 12.6485C16.4736 12.4235 16.6 12.1183 16.6 11.8V4.6C16.6 4.28174 16.4736 3.97652 16.2485 3.75147C16.0235 3.52643 15.7183 3.4 15.4 3.4H13.1875C12.8631 3.4 12.5556 3.22112 12.3453 2.9755Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80078 10.6016C10.4576 10.6016 11.8008 9.25842 11.8008 7.60156C11.8008 5.94471 10.4576 4.60156 8.80078 4.60156C7.14393 4.60156 5.80078 5.94471 5.80078 7.60156C5.80078 9.25842 7.14393 10.6016 8.80078 10.6016Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84922 3.325V2.5H2.94922V3.325",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCapture);
export default __webpack_public_path__ + "static/media/camera_capture.6592cf712a2efd81fd7b383edef1dad7.svg";
export { ForwardRef as ReactComponent };